// Map lowercase author names to profile URLs
const collaboratorLinks = {
  "asm ahsan-ul haque": "https://www.linkedin.com/in/ahsantarique/",
  "aswin rrv": "https://3rdat.github.io/",
  "aswin ravikumar rangasamy veerasamy": "https://3rdat.github.io/",
  "avneet ahuja": "https://avneetahuja.vercel.app/",
  "ben zhou": "http://xuanyu.me/",
  "chitta baral": "https://chitta.orissalinks.com/www/",
  "divij handa": "https://divijhanda.in/",
  "hoifung poon": "https://www.microsoft.com/en-us/research/people/hoifung/",
  "irbaz b. riaz":
    "https://www.mayoclinic.org/biographies/riaz-irbaz-b-m-b-b-s-ph-d/bio-20557446",
  "irbaz bin riaz":
    "https://www.mayoclinic.org/biographies/riaz-irbaz-b-m-b-b-s-ph-d/bio-20557446",
  "md nayem uddin": "https://www.linkedin.com/in/muddin11",
  "mihir parmar": "https://sites.google.com/view/mihir3009",
  "ming shen": "https://www.linkedin.com/in/ming-shen-50ba4b226",
  "muhao chen": "https://luka-group.github.io/",
  "qin liu": "https://qinliu9.github.io/",
  "sheng zhang": "https://sheng-z.github.io/",
  "xiao ye": "https://itok2000u.github.io/",
  "zhaonan li": "https://lzn87.github.io/",
  "zhikun xu": "https://jerrrrykun.github.io/",
  "zhikun zu": "https://jerrrrykun.github.io/", // fallback for common typo
  "shijie lu": "https://shijie-lu.com/",
  "yuxi huang": "https://yuxihh.github.io/",
  "weiyu chen": "https://search.asu.edu/profile/5051358",
  "muhammad umar afzal":
    "https://scholar.google.com/citations?user=J4O5aloAAAAJ&hl=en",
  "umar afzal": "https://scholar.google.com/citations?user=J4O5aloAAAAJ&hl=en",
  "phu tran": "https://tranngocphu.github.io/",
}

export default collaboratorLinks
